export var QuickAddTreeNodeType;
(function (QuickAddTreeNodeType) {
    QuickAddTreeNodeType[QuickAddTreeNodeType["Toolbox"] = 0] = "Toolbox";
    QuickAddTreeNodeType[QuickAddTreeNodeType["Data"] = 1] = "Data";
    QuickAddTreeNodeType[QuickAddTreeNodeType["Integrations"] = 2] = "Integrations";
    QuickAddTreeNodeType[QuickAddTreeNodeType["Registrations"] = 3] = "Registrations";
    QuickAddTreeNodeType[QuickAddTreeNodeType["Existing"] = 4] = "Existing";
    QuickAddTreeNodeType[QuickAddTreeNodeType["Recent"] = 5] = "Recent";
    QuickAddTreeNodeType[QuickAddTreeNodeType["Favorite"] = 6] = "Favorite";
})(QuickAddTreeNodeType || (QuickAddTreeNodeType = {}));
;
